// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1xmRg","legacyBtn":"MutateMid_legacyBtn__29dc0"};